import { motion } from "framer-motion";
import { Sparkles, Star } from "lucide-react";

const stats = [
  { value: "2026", label: "SINCE", testid: "stat-since" },
  { value: "24", label: "HOUR STANDBY / DAY", testid: "stat-standby" },
  { value: "5", label: "VARIASI GAME", testid: "stat-games" },
  { value: "100%", label: "TERPERCAYA", testid: "stat-trusted" },
];

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: i * 0.12, ease: "easeOut" },
  }),
};

export default function Home() {
  return (
    <section
      data-testid="home-page"
      className="flex min-h-screen flex-col items-center justify-center px-6 pb-20 pt-32 text-center"
    >
      <motion.div
        variants={fadeUp}
        initial="hidden"
        animate="show"
        custom={0}
        data-testid="home-badge"
        className="glass-card flex items-center gap-2 rounded-full px-5 py-2"
      >
        <Sparkles size={13} className="text-emerald-300" />
        <span className="font-display text-[11px] font-semibold tracking-[0.35em] text-emerald-200">
          TRUSTED TEAM
        </span>
        <Sparkles size={13} className="text-emerald-300" />
      </motion.div>

      <motion.h1
        variants={fadeUp}
        initial="hidden"
        animate="show"
        custom={1}
        data-testid="home-title"
        className="font-display mt-10 text-6xl font-bold tracking-wide sm:text-7xl lg:text-8xl"
      >
        <span className="text-emerald-300 text-glow-emerald">TEAM</span>
        <span className="gold-text">JAV</span>
      </motion.h1>

      <motion.div
        variants={fadeUp}
        initial="hidden"
        animate="show"
        custom={2}
        className="animate-float relative mt-12 flex h-52 w-52 items-center justify-center rounded-full"
        style={{ boxShadow: "0 0 90px rgba(52,211,153,0.35)" }}
        data-testid="home-emblem"
      >
        <div className="absolute inset-0 rounded-full border-2 border-emerald-300/60" />
        <div className="absolute inset-1 rounded-full border border-emerald-200/20" />
        <div className="gold-coin absolute inset-3 flex flex-col items-center justify-center rounded-full">
          <span className="font-display text-[10px] font-semibold tracking-[0.4em] text-[#5b3a04]">TEAM</span>
          <span className="font-display text-5xl font-bold leading-none text-[#4a2e02]">JAV</span>
          <div className="mt-1 flex items-center gap-1 text-[#6b4506]">
            <Star size={11} fill="currentColor" />
            <Star size={13} fill="currentColor" />
            <Star size={11} fill="currentColor" />
          </div>
        </div>
      </motion.div>

      <motion.p
        variants={fadeUp}
        initial="hidden"
        animate="show"
        custom={3}
        data-testid="home-tagline"
        className="mt-12 text-sm font-medium tracking-[0.45em] text-emerald-100/70"
      >
        JAV is The Best
      </motion.p>

      <motion.h2
        variants={fadeUp}
        initial="hidden"
        animate="show"
        custom={4}
        data-testid="home-subtitle"
        className="font-display mt-4 text-lg font-bold tracking-[0.2em] text-emerald-300 text-glow-emerald md:text-2xl"
      >
        FIRST MIXED COUNTRY GROWTOPIA TEAM
      </motion.h2>

      <div className="mt-16 grid w-full max-w-3xl grid-cols-2 gap-4 md:grid-cols-4">
        {stats.map((s, i) => (
          <motion.div
            key={s.testid}
            variants={fadeUp}
            initial="hidden"
            animate="show"
            custom={5 + i}
            data-testid={s.testid}
            className="glass-card rounded-2xl px-4 py-6 transition-transform duration-300 hover:-translate-y-1"
          >
            <div className="gold-text font-display text-3xl font-bold md:text-4xl">{s.value}</div>
            <div className="mt-2 text-[10px] font-semibold tracking-[0.25em] text-emerald-100/50">
              {s.label}
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
